export default function DataConnectorIco({ color }) {
  return (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 0.0498047C11.5247 0.0498052 11.9502 0.47533 11.9502 1V4.0498H13C14.6292 4.04981 15.9502 5.37076 15.9502 7V10C15.9502 13.2861 13.2861 15.9502 10 15.9502H8.9502V19C8.9502 19.5247 8.52467 19.9502 8 19.9502C7.47533 19.9502 7.0498 19.5247 7.0498 19V15.9502H6C2.71391 15.9502 0.0498047 13.2861 0.0498047 10V7C0.0498047 5.37076 1.37076 4.0498 3 4.0498H4.0498V1C4.0498 0.475329 4.47533 0.0498047 5 0.0498047C5.52467 0.0498049 5.9502 0.47533 5.9502 1V4.0498H10.0498V1C10.0498 0.475329 10.4753 0.0498047 11 0.0498047ZM3 5.9502C2.4201 5.9502 1.9502 6.4201 1.9502 7V10C1.9502 12.2368 3.76325 14.0498 6 14.0498H10C12.2368 14.0498 14.0498 12.2368 14.0498 10V7C14.0498 6.4201 13.5799 5.9502 13 5.9502H3Z"
        fill={color || "#8396A8"}
        stroke="white"
        stroke-width="0.1"
      />
    </svg>
  );
}
